import pino from 'pino'
import type { IUserContext } from './userContext'

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const LOG_LEVEL = process.env.LOG_LEVEL || 'info'
const getOps = () => {
  return {
    level: LOG_LEVEL,
    timestamp: () => `,"time":"${new Date().toISOString()}"`,
  }
}
export const logger = pino(getOps())

// Lazy import getUserContext only on server to avoid bundling async_hooks
type IGetUserContextFn = () => IUserContext | undefined
let getUserContext: IGetUserContextFn | null = null

if (typeof window === 'undefined') {
  // Server-side only: dynamically load userContext to avoid bundling async_hooks for client
  /* eslint-disable @typescript-eslint/no-require-imports */
  /* eslint-disable @typescript-eslint/no-var-requires */
  /* eslint-disable @typescript-eslint/no-unsafe-assignment */
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  try {
    const userContextModule = require('./userContext')
    getUserContext = userContextModule.getUserContext as IGetUserContextFn
  } catch {
    // In test environment or when userContext can't be loaded, proceed without it
    getUserContext = null
  }
}

function getContextLogger() {
  if (!getUserContext) return logger

  const context = getUserContext()
  if (!context) return logger

  return logger.child({
    userId: context.userId,
    email: context.email,
    sessionId: context.sessionId,
    ip: context.ip,
  })
}

export const log = {
  info: (message: string) => {
    getContextLogger().info(message)
  },
  debug: (message: string) => {
    getContextLogger().debug(message)
  },
  error: (message: string) => {
    getContextLogger().error(message)
  },
  warn: (message: string) => {
    getContextLogger().warn(message)
  },
}
export default log
